import request from '@/plugin/axios'

export function ListDomains (data) {
  return request({
    url: '/domain/index',
    method: 'get',
    params: data
  })
}

export function ViewDomain (id) {
  return request({
    url: '/domain/view?id=' + id,
    method: 'get'
  })
}

export function CreateDomain (data) {
  return request({
    url: '/domain/create',
    method: 'post',
    data
  })
}

export function UpdateDomain (data) {
  return request({
    url: '/domain/update?id=' + data.id,
    method: 'post',
    data
  })
}

export function DeleteDomain (id) {
  return request({
    url: '/domain/delete?id=' + id,
    method: 'delete'
  })
}
